import styled, { css } from 'styled-components';

import { Button } from '@cambridgeassessment/cambridge-ui';

interface ReadOnly {
  readOnly?: boolean;
}

export const StyledAccordion = styled.div`
  .MuiAccordionSummary-root {
    padding: 0px;
  }

  .MuiAccordionDetails-root {
    padding: 0px;
  }
`;

export const StyledComponentButton = styled(Button)`
  white-space: nowrap;
`;

const StyledReadOnlyComponentCSS = css`
  pointer-events: ${(props: ReadOnly): string => (props.readOnly ? 'none' : '')};
  opacity: ${(props: ReadOnly): string => (props.readOnly ? '0.7' : '')};
`;

export const StyledReadOnlyComponent = styled.div<ReadOnly>`
  ${StyledReadOnlyComponentCSS}
  max-width: 43.5rem;
  width: 100%;
`;

export const StyledAddButtonContainer = styled.div`
  width: 230px;
  margin-top: 24px;
`;

export const StyledComponentHeaderText = styled.h3`
  font-family: SourceSansPro;
  font-size: 26px;
  font-weight: bold;
  line-height: 1.28;
  flex-shrink: 0;
  letter-spacing: normal;
  text-align: left;
  width: auto;
  margin: 0;
`;

export const StyledExpansionPanelDetails = styled.div`
  padding: 8px 0 24px 0px;
  flex-direction: column;
`;

export const StyledComponentParagraphText = styled.p`
  font-size: 16px;
`;

export const StyledComponentHeaderContainer = styled.div`
  display: flex;
  margin-top: 32px;
  margin-bottom: 20px;
  align-items: center;
`;
